module.exports = __webpack_public_path__ + "static/media/oberflex-teck-1200x2490.34479e5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-teck-1200x2490.jpg
// module id = 1058
// module chunks = 37